import { AbstractControl, ValidationErrors } from '@angular/forms';
  
export class WhiteSpaceValidator {
    static cannotContainSpace(control: AbstractControl) : ValidationErrors | null {
       
        if(control.value !=undefined && typeof(control.value) == "string" && !((control.value as string).trim() != "")){
            return {cannotContainSpace: true}
        }
  
        return null;
    }
}